import { Injectable, inject } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, from, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { KeycloakService } from 'keycloak-angular';
import { Router } from '@angular/router';
import { PathEnum } from '../enum/path.enum';

@Injectable()
export class KeycloakTokenInterceptor implements HttpInterceptor {
  private keycloakService = inject(KeycloakService);
  private router = inject(Router);

  private readonly MIN_TOKEN_VALIDITY = 30;

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.shouldSkipTokenRefresh(req.url)) {
      return next.handle(req);
    }

    if (!this.keycloakService.isLoggedIn()) {
      return next.handle(req);
    }

    return from(this.updateTokenIfNeeded()).pipe(
      switchMap(() => next.handle(req)),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          return this.handle401Error(req, next);
        }
        return throwError(() => error);
      })
    );
  }


  private async updateTokenIfNeeded(): Promise<boolean> {
    try {
      const refreshed = await this.keycloakService.updateToken(this.MIN_TOKEN_VALIDITY);
      if (refreshed) {
      }
      return refreshed;
    } catch (error) {
      console.error('Failed to refresh Keycloak token:', error);
      await this.handleTokenRefreshFailure();
      throw error;
    }
  }

  private handle401Error(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return from(this.forceTokenRefresh()).pipe(
      switchMap(() => {
        return next.handle(req);
      }),
      catchError((error) => {
        this.handleTokenRefreshFailure();
        return throwError(() => error);
      })
    );
  }


  private async forceTokenRefresh(): Promise<boolean> {
    try {
      return await this.keycloakService.updateToken(-1);
    } catch (error) {
      throw error;
    }
  }


  private async handleTokenRefreshFailure(): Promise<void> {

    sessionStorage.clear();

    try {
      await this.keycloakService.logout(window.location.origin);
    } catch (error) {
      this.router.navigate([PathEnum.Auth]);
    }
  }


  private shouldSkipTokenRefresh(url: string): boolean {
    const skipUrls = [
      'identity.trangle.io',
      '/assets/',
      '/qr-session',
      '/qr/session',
      '/qr/approvals',
      '/system-settings/qr-session',
    ];
    return skipUrls.some((skipUrl) => url.includes(skipUrl));
  }
}

